import React, { useState } from 'react';
import { Grid, makeStyles, Paper, Tab, Tabs } from '@material-ui/core';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import KambriaEditor from '@kambria/ckeditor5-react';
import { InputField } from './form';
import UploadImageAdapterPlugin from './UploadImageAdapterPlugin';
import { connect } from 'react-redux';
import './css/editable.css';

const useStyles = makeStyles((theme) => ({
  ckeditor: {
    '& > .ck-content': {
      height: '420px',
      overflow: 'auto',
    },
    '& > .ck-editor > .ck-editor__top': {
      position: 'sticky',
      top: 0,
      backgroundColor: '#ffffff',
      zIndex: 1,
    },
    '& > .ck-editor > .ck-editor__main > .ck-toolbar': {
      position: 'sticky',
      top: 0,
      backgroundColor: '#ffffff',
      zIndex: 1,
      fontSize: '11px',
    },
  },
  htmlWrapper: {
    height: theme.spacing(60),
    overflow: 'overlay',
  },
  preview: {
    flex: 1,
    backgroundColor: '#f2f2f2',
    padding: theme.spacing(10),
  },
  previewPaper: {
    padding: theme.spacing(10),
    height: '100%',
    overflow: 'auto',
    maxWidth: '100%',
    boxShadow: '0 1rem 3rem rgba(0,0,0,.175)!important',
    borderRadius: '1rem',
  },
}));

function TabPanel({ children, value, current }) {
  return (
    <div role="tabpanel" hidden={value !== current} id={value}>
      {children}
    </div>
  );
}

function EditorField({ name, value, onChange }) {
  const classes = useStyles();
  const [currentTab, setCurrentTab] = useState('editor');
  const onEditorChange = (_, editor) => {
    const value = editor.getData();
    onChange({ target: { name, value } });
  };
  let kEditor = null;

  function UploadAdapterPlugin(editor) {
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
      return new UploadImageAdapterPlugin(loader);
    };
  }

  const custom_config = {
    extraPlugins: [UploadAdapterPlugin],
    table: {
      contentToolbar: [
        'toggleTableCaption',
        'tableColumn',
        'tableRow',
        'mergeTableCells',
        'tableProperties',
        'tableCellProperties',
      ],
    },
    fontSize: {
      options: ['default', 12, 16, 18, 24, 32],
    },
    heading: {
      options: [
        { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
        { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
        { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
        { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
        { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
        { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
        { model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6' },
      ],
    },
    image: {
      // You need to configure the image toolbar, too, so it uses the new style buttons.
      toolbar: [
        'imageTextAlternative',
        'toggleImageCaption',
        'linkImage',
        '|',
        'imageStyle:alignLeft',
        'imageStyle:alignCenter',
        'imageStyle:alignRight',
        '|',
        'resizeImage',
      ],
      styles: ['alignCenter', 'alignLeft', 'alignRight'],
      resizeOptions: [
        {
          name: 'resizeImage:original',
          value: null,
          icon: 'original',
        },
        {
          name: 'resizeImage:25',
          value: '25',
          icon: 'small',
        },
        {
          name: 'resizeImage:50',
          value: '50',
          icon: 'medium',
        },
        {
          name: 'resizeImage:75',
          value: '75',
          icon: 'large',
        },
        {
          name: 'resizeImage:100',
          value: '100',
          icon: 'original',
        },
      ],
    },
    link: {
      decorators: {
        openInNewTab: {
          mode: 'manual',
          label: 'Open link in a new tab',
          defaultValue: true, // This option will be selected by default.
          attributes: {
            target: '_blank',
          },
        },
      },
    },
    mediaEmbed: {
      previewsInData: true,
    },
  };

  return (
    <Grid container className="cktabs">
      <Grid item xs={12} md={12} sm={12}>
        <Tabs onChange={(_, v) => setCurrentTab(v)} value={currentTab}>
          <Tab label="Editor" value="editor" style={{ textTransform: 'none' }} />
          <Tab label="Preview" value="preview" style={{ textTransform: 'none' }} />
          <Tab label="Html" value="html" style={{ textTransform: 'none' }} />
        </Tabs>
      </Grid>
      <Grid item xs={12} sm={12} md={12}>
        <TabPanel value="editor" current={currentTab}>
          <div className={classes.ckeditor}>
            <CKEditor
              onReady={(editor) => {
                if (!editor) return;
                editor.ui
                  .getEditableElement()
                  .parentElement.insertBefore(editor.ui.view.toolbar.element, editor.ui.getEditableElement());
                kEditor = editor;
                kEditor.setData(value);
              }}
              onError={({ willEditorRestart }) => {
                if (willEditorRestart) {
                  kEditor.ui.view.toolbar.element.remove();
                }
              }}
              onChange={onEditorChange}
              editor={KambriaEditor}
              config={custom_config}
            />
          </div>
        </TabPanel>
        <TabPanel value="html" current={currentTab}>
          <div className={classes.htmlWrapper}>
            <InputField name={name} onChange={onChange} value={value} multiline rows={20} />
          </div>
        </TabPanel>
        <TabPanel value="preview" current={currentTab}>
          <div className={classes.preview}>
            <Paper className={classes.previewPaper} elevation={2} dangerouslySetInnerHTML={{ __html: value }} />
          </div>
        </TabPanel>
      </Grid>
    </Grid>
  );
}

export default connect(() => ({}))(EditorField);
